import { Lock, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";

export default function UnauthorizedPage() {
  const handleLogin = () => {
    window.location.href = "/login";
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 brushed-steel vignette-deep">
      <Card className="max-w-md w-full machined-edge bg-pro-gunmetal/80 border-pro-gunmetal">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-amber-500/20 rounded-full flex items-center justify-center mb-4 border border-amber-500/30">
            <Lock className="w-8 h-8 text-amber-500" />
          </div>
          <CardTitle className="text-2xl text-white font-broadcast">AUTHENTICATION REQUIRED</CardTitle>
          <CardDescription className="text-base mt-2 text-white/70">
            You need to sign in to access this page.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center text-sm text-white/60">
          <p>Sign in to continue using Dugout Desk.</p>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button onClick={handleLogin} size="lg" data-testid="button-sign-in" className="bg-pro-field hover:bg-pro-field/90 font-broadcast">
            <LogIn className="w-4 h-4 mr-2" />
            Sign In
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
